export const NAV = ["Home", "About", "Timeline", "Petition", "Social", "Hall of Fame", "Gallery"];

export const TIMELINE = [
  { date: "Feb 1",  label: "Registration Opens",   desc: "Submit your project proposal through the portal.",  done: true  },
  { date: "Mar 15", label: "Submission Deadline",   desc: "Final project files and documentation due.",        done: true  },
  { date: "Apr 5",  label: "Finalist Announced",    desc: "Top 24 teams notified via email.",                  done: true  },
  { date: "May 10", label: "Expo Day 1",             desc: "Project demos, workshops & opening ceremony.",      done: false },
  { date: "May 11", label: "Expo Day 2",             desc: "Panel judging, sponsor meetings & keynotes.",       done: false },
  { date: "May 12", label: "Awards Night",           desc: "Closing ceremony & prize distribution.",            done: false },
];

export const CATEGORIES = [
  { icon: "⬡", title: "AI & Machine Learning", desc: "Neural networks, computer vision, NLP, and intelligent systems." },
  { icon: "◈", title: "Cybersecurity",          desc: "Ethical hacking, cryptography, and network defense systems." },
  { icon: "◻", title: "Web & Cloud",            desc: "Full-stack platforms, microservices, and scalable infrastructure." },
  { icon: "◆", title: "Robotics & IoT",         desc: "Embedded systems, automation, and hardware integration." },
  { icon: "◯", title: "Data Science",           desc: "Analytics, visualization, and large-scale data pipelines." },
  { icon: "▲", title: "Game Development",       desc: "Interactive experiences, simulations, and game engines." },
  { icon: "◇", title: "Blockchain",             desc: "Decentralized apps, smart contracts, and tokenomics." },
  { icon: "●", title: "Biocomputing",           desc: "Bioinformatics, computational biology, and health tech." },
];

export const FINALISTS = [
  { id: "01", name: "NeuralGuard", team: "Team Alpha",   cat: "Cybersecurity",  score: 96 },
  { id: "02", name: "FlowSync AI", team: "Team Beta",    cat: "AI & ML",        score: 94 },
  { id: "03", name: "ChainVault",  team: "Team Gamma",   cat: "Blockchain",     score: 91 },
  { id: "04", name: "BioMap",      team: "Team Delta",   cat: "Biocomputing",   score: 89 },
  { id: "05", name: "SkyMesh",     team: "Team Epsilon", cat: "IoT",            score: 88 },
  { id: "06", name: "DataForge",   team: "Team Zeta",    cat: "Data Science",   score: 87 },
];

export const SPONSORS = [
  { tier: "Platinum", name: "TechCorp Global"   },
  { tier: "Platinum", name: "CloudNova Systems" },
  { tier: "Gold",     name: "ByteForge Labs"    },
  { tier: "Gold",     name: "Quanta Research"   },
  { tier: "Gold",     name: "NexaData Inc."     },
  { tier: "Silver",   name: "OpenStack Co."     },
  { tier: "Silver",   name: "CipherNet"         },
  { tier: "Silver",   name: "VectorAI"          },
];

export const HALL = [
  { year: "2025", winner: "NeuralEdge",  team: "Team Orion", cat: "AI & ML",       award: "Grand Champion" },
  { year: "2025", winner: "CipherX",     team: "Team Nova",  cat: "Cybersecurity", award: "Runner Up"      },
  { year: "2024", winner: "QuantumBot",  team: "Team Apex",  cat: "Robotics",      award: "Grand Champion" },
  { year: "2024", winner: "DataStream",  team: "Team Flux",  cat: "Data Science",  award: "Runner Up"      },
  { year: "2023", winner: "BlockLink",   team: "Team Zero",  cat: "Blockchain",    award: "Grand Champion" },
  { year: "2023", winner: "BioScan",     team: "Team Echo",  cat: "Biocomputing",  award: "Runner Up"      },
];

export const SOCIAL_CHANNELS = [
  { id: "01", name: "Instagram",   handle: "@scicom2026",        cat: "Photos & Reels",       score: 98, color: "#e1306c" },
  { id: "02", name: "TikTok",      handle: "@scicom_summit",     cat: "Short Videos",         score: 95, color: "#69c9d0" },
  { id: "03", name: "Facebook",    handle: "SCI-COM Summit",     cat: "Updates & Events",     score: 91, color: "#1877f2" },
  { id: "04", name: "Twitter / X", handle: "@scicom2026",        cat: "Live Updates",         score: 88, color: "#c8d0e0" },
  { id: "05", name: "YouTube",     handle: "SCI-COM Official",   cat: "Talks & Demos",        score: 86, color: "#ff0000" },
  { id: "06", name: "LinkedIn",    handle: "SCI-COM Summit",     cat: "Professional Network", score: 83, color: "#0a66c2" },
];

export const GALLERY_ITEMS = [
  { label: "Opening Ceremony 2025", tag: "ceremony", span: 2 },
  { label: "Project Demo Floor",    tag: "expo",     span: 1 },
  { label: "Keynote Speaker",       tag: "keynote",  span: 1 },
  { label: "Award Night 2024",      tag: "awards",   span: 1 },
  { label: "Workshop: AI Lab",      tag: "workshop", span: 1 },
  { label: "Team Networking",       tag: "social",   span: 2 },
];
